//Users.js
import { use } from 'i18next';
import api from '../../services/api';
import { useQuery, useMutation } from "@tanstack/react-query";
import { useGetVendorId } from '../global/User';


export const useGetVendors = (vendorIds) => {
    const fetchData = async () => {
        const { data } = await api.get(`${process.env.REACT_APP_API_URL}/users/vendors/?vendorIds=${vendorIds}`);
        return data;
    };
    return useQuery({ queryKey: ['vendors'], queryFn: fetchData, enabled: true });
}


// Custom hook for checking auth status
export const useCheckAuthStatus = () => {
    const vendorId = useGetVendorId();

    const fetchStatus = async () => {
        const token = localStorage.getItem('token');
        const isAuth = localStorage.getItem('isAuthenticated');
        const vendorId = localStorage.getItem('vendorId');

        if (!token && !isAuth) return false;

        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/users/status?vendorId=${vendorId}`, {
                    headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data.isAuthenticated) {
                localStorage.setItem('isAuthenticated', response.data.isAuthenticated);
            }
            return response.data;

        } catch (error) {
            console.error("Error fetching user status:", error);
            return { data: { isAuthenticated: false } };
        }
    };

    const { isLoading, isError, error, data } = useQuery(['userStatus', vendorId], fetchStatus, {
            enabled: !!vendorId, // Only run query when vendorId is available
            refetchOnWindowFocus: true, // Refetch when window regains focus
            refetchOnMount: true, // Refetch when component mounts
        }
    );

    return { isLoading, isError, error, data };
};


export const useLoginMutation = (setIsAuthenticated, setAuthError) => {
    return useMutation(async ({username, password}) => {
        try {
            const { data } = await api.post(`${process.env.REACT_APP_API_URL}/users/login`, { username, password });
            localStorage.setItem('token', data.token);
            localStorage.setItem('isAuthenticated', true);
            localStorage.setItem('user', JSON.stringify(data.user));
            localStorage.setItem('vendor', JSON.stringify(data.vendor));
            localStorage.setItem('vendorId', data.vendor.id);
            localStorage.setItem('admin', null);
            setIsAuthenticated(true);
            setAuthError(null); // Clear any previous error
            return data;
        } catch (error) {
            setAuthError(error);
        }
    });
};


export const useResetPasswordToken = () => {
    return useMutation(async ({username, lng}) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/users/password`, { username, lng });
        return data;
    });
};
export const useResetPassword = () => {
    return useMutation(async ({resetToken, password, lng}) => {
        const { data } = await api.post(`${process.env.REACT_APP_API_URL}/users/password/update`, { resetToken, password, lng });
        return data;
    });
};